import '../shared/types';

/**
 * @typedef {object} CareerAndSeasonStatsState
 * @property {CareerAndSeasonStatsNavState} nav
 * @property {StatsSortState} sort
 * @property {StatsBenchmarkingState} benchmarking
 * @property {CareerAndSeasonStatsDataTypeState} dataType
 * @property {CareerAndSeasonStatsRequestDetails[]} requests
 * @property {any} data
 */

/**
 * @typedef {object} CareerAndSeasonStatsNavState
 * @property {string} category
 * @property {object} competition
 * @property {number|null} competition.id
 * @property {object} season
 * @property {number|null} season.id
 */

/**
 * @typedef {object} CareerAndSeasonStatsDataTypeState
 * @property {'totals'|'averages'|'benchmarkedTotals'|'benchmarkedAverages'} dataType.type
 */

/**
 * @typedef {object} CareerAndSeasonStatsRequestDetails
 * @property {string} id
 * @property {'rounds'|'seasons'} type
 * @property {boolean} benchmarking
 */
